// extracted by mini-css-extract-plugin
export default {"notRegistered":"RegisterComponent_notRegistered__4VSKk"};